// Validation shared by the "Add customer" and "Create order" forms; the server enforces the same rules (backend/manual_orders.py).
const tidy = (v) => String(v ?? "").replace(/\s+/g, " ").trim();
const hasLetter = (v) => /\p{L}/u.test(v);

export function normMobile(v) {
  let d = String(v ?? "").replace(/[\s\-().]/g, "");
  if (d.startsWith("+")) d = d.slice(1);
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d;
}

/** Returns { field: message } for every problem. `delivery` makes the address block required. */
export function personErrors(f, { delivery = false } = {}) {
  const e = {};
  const name = tidy(f.name);
  if (!name) e.name = "Name is required.";
  else if (name.length < 2) e.name = "Name must be at least 2 characters.";
  else if (name.length > 80) e.name = "Name must be at most 80 characters.";
  else if (!hasLetter(name)) e.name = "Name must contain letters.";
  if (!tidy(f.mobile)) e.mobile = "Mobile number is required.";
  else if (!/^[6-9]\d{9}$/.test(normMobile(f.mobile))) e.mobile = "Enter a valid 10-digit mobile number (starting with 6, 7, 8 or 9).";
  const email = tidy(f.email);
  if (email.length > 120) e.email = "Email is too long.";
  else if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) e.email = "Enter a valid email or leave it blank.";
  const addr = tidy(f.address), city = tidy(f.city), state = tidy(f.state), pin = String(f.pincode ?? "").replace(/\s/g, "");
  if (addr && addr.length < 5) e.address = "Address looks too short.";
  else if (addr.length > 300) e.address = "Address must be at most 300 characters.";
  else if (delivery && !addr) e.address = "Delivery address is required.";
  if (city && !hasLetter(city)) e.city = "City must contain letters.";
  else if (city.length > 60) e.city = "City is too long.";
  else if (delivery && !city) e.city = "City is required.";
  if (state && !hasLetter(state)) e.state = "State must contain letters.";
  else if (state.length > 60) e.state = "State is too long.";
  else if (delivery && !state) e.state = "State is required.";
  if (pin && !/^[1-9]\d{5}$/.test(pin)) e.pincode = "Pincode must be 6 digits.";
  else if (delivery && !pin) e.pincode = "Pincode is required.";
  if (String(f.notes ?? "").length > 500) e.notes = "Notes must be at most 500 characters.";
  return e;
}
